const isPracticeUser = (enrollmentData, userGuid) => {
  const { practiceAdminGuid } = enrollmentData;

  return practiceAdminGuid ? practiceAdminGuid === userGuid : false;
};

export default isPracticeUser;
